"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createCustomSoapHeader(deviceId) {
    return "<soap:Header><ClientInformation xmlns=\"http://schemas.microsoft.com/winfx/2006/xaml/presentation\">" + deviceId + "</ClientInformation></soap:Header>";
}
function insertArcusCustomDataHeader(challenge, deviceId) {
    var soapBodyStartIndex = challenge.indexOf('<soap:Body>');
    var beforeBody = challenge.slice(0, soapBodyStartIndex);
    var afterBody = challenge.slice(soapBodyStartIndex);
    return beforeBody + createCustomSoapHeader(deviceId) + afterBody;
}
var arcusPlayreadyRequestDecorator = function (wrappedHttpLicenseRequestGenerator) { return function (drmConfiguration, message, messageType) {
    var httpLicenseRequest = wrappedHttpLicenseRequestGenerator(drmConfiguration, message, messageType);
    if (drmConfiguration.deviceId) {
        httpLicenseRequest.body = insertArcusCustomDataHeader(httpLicenseRequest.body, drmConfiguration.deviceId);
    }
    httpLicenseRequest.headers = {
        'Content-Type': 'text/plain',
    };
    return httpLicenseRequest;
}; };
exports.default = arcusPlayreadyRequestDecorator;
